import { useRequest } from 'ahooks'
import { Message } from '@/components'
import { t } from '@/i18n'
import {
  getHostList,
  getSecurityDomainList,
  GetHostList,
  UpdateHost,
  updateHost,
  getHostDetail,
} from '@/api/asset-management/verify-host'

// 获取验证主机列表
export const useGetHostList = () => {
  const {
    runAsync: run,
    loading,
    data,
  } = useRequest((params: GetHostList) => getHostList(params), {
    manual: true,
    onError: (error: any) => {
      Message.error(error.msg || t('获取验证主机列表失败'))
    },
  })

  return [run, loading, data?.data?.list || []] as const
}

// 更新验证主机信息
export const useUpdateHost = () => {
  const { runAsync: run, loading } = useRequest((data: UpdateHost) => updateHost(data), {
    manual: true,
    onError: (error: any) => {
      Message.error(error.msg || t('更新验证主机信息失败'))
    },
  })

  return [run, loading] as const
}

// 获取验证主机详情
export const useGetHostDetail = () => {
  const { runAsync: run, data } = useRequest((id: string) => getHostDetail(id), {
    manual: true,
    onError: (error: any) => {
      Message.error(error.msg || t('获取验证主机详情失败'))
    },
  })

  return [run, data?.data || {}] as const
}

// 获取安全域列表
export const useGetSecurityDomainList = () => {
  const { runAsync: run, data } = useRequest(getSecurityDomainList, {
    manual: true,
    onError: (error: any) => {
      Message.error(error.msg || t('获取安全域列表失败'))
    },
  })

  return [run, data?.data?.items || []] as const
}
